module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAGmb2P///yH5BAAHAP8ALAAAAAAMAAwAAAIUhI+pGx182opPuTqBzBvh7jnZmBUAOw=="